export enum CreateNewRoomStepsEnum {
  CREATE_ROOM = 'create-room',
  INVITE_PARTICIPANTS = 'invite-participants',
  SET_AUTO_REMINDERS = 'set-auto-reminders',
  REVIEW_ROOM = 'review-room',
  DISCARD = 'discard',
}
